module.exports = "<div class=\"preloader\">\r\n\t\t<div class=\"preloader_image\"></div>\r\n\t</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/page/loading-page/loading-page.component.html
// module id = ./src/app/components/page/loading-page/loading-page.component.html
// module chunks = main